<template>
  <div class="buy-feature">
    <div class="header">
      <div>
        <span class="text-16 font-medium text-font-1">
          {{ $t('xuan-ze-jia-gou-rong-liang') }}
        </span>
        <span class="text-12 leading-[17px] text-font-60">
          {{ $t('gou-mai-hou-you-xiao-qi-zhi-expireformat', [expireFormat()]) }}
        </span>
      </div>
    </div>
    <div class="buy-feature__desc">
      {{ $t('jia-gou-cun-chu-kong-jian-gou-mai-cheng-gong-hou-li-ji-sheng-xiao') }}
    </div>
    <div class="product_list">
      <div
        v-for="item of packageList"
        :key="item.id"
        class="product_item"
        :class="{
          selected: item.id === modelRef.current?.id && packageList.length > 1,
        }"
        @click="handleSelectPackage(item)"
      >
        <iconpark-icon
          v-if="item.id === modelRef.current?.id && packageList.length > 1"
          name="xuanzhong"
          size="24"
          class="absolute top-[10px] right-[10px]"
        ></iconpark-icon>
        <div>
          <span class="text-[20px] rounded-[28px] text-font-1 font-semibold">
            1{{ item.type }}
          </span>
        </div>
        <div class="flex flex-nowrap justify-between py-[12px]">
          <div class="product_price text-16">
            <span class="text-[#FF2C2C]">
              {{ formatPrice(item.price).prefix }}
            </span>
            <span class="text-[28px] leading-[22px] text-[#FF2C2C]">
              {{ formatPrice(item.price).value }}
            </span>
            <span class="text-font-60">/{{ $t('nian') }}</span>
          </div>
          <div class="text-14 text-font-40 flex items-end line-through">
            {{ item.oldPrice }}
          </div>
        </div>
        <div class="flex flex-nowrap">
          <div class="flex justify-center items-center text-14 text-font-70">
            {{ $t('gou-mai') }}
          </div>
          <div @click.stop.prevent="handleSelectPackage(item)">
            <a-input-number
              type="number"
              class="w-[100px] ml-[20px] mr-[10px]"
              :value="tempInputValues[item.id]"
              :min="item.min"
              :step="1"
              :formatter="v => parseInt(String(v)).toString() || '1'"
              :max="item.max"
              :default-value="1"
              inputmode="numeric"
              pattern="\d*"
              :placeholder="$t('qing-shu-ru-shu-liang')"
              autocomplete="off"
              :precision="0"
              @change="handleInputChange"
            />
          </div>
          <div class="unit flex justify-center items-center text-14 text-font-70">
            {{ item.type }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts" name="StorageInfo">
import type { valueType } from 'ant-design-vue/es/statistic/utils';
import { RIGHTS_FEATURE } from '~/api/interface/rights';
import { useTime } from '~/hooks/useTime';
import { formatPrice } from '~/utils/equity-helper';

const props = withDefaults(
  defineProps<{
    rightsName: string;
    featureType: RIGHTS_FEATURE;
    packageList: any[];
    count: number;
    currentPackage: any;
  }>(),
  {
    packageList: () => [],
  },
);

const emits = defineEmits(['update:count', 'update:currentPackage']);

const tempInputValues = ref<{ [key: number]: number }>({});
props.packageList.forEach((item: any) => {
  tempInputValues.value[item.id] = 1;
});

const modelRef = reactive({
  count: props.count || 1,
  current: props?.currentPackage,
});

const handleSelectPackage = (values: any) => {
  if (values.id !== modelRef.current?.id) {
    modelRef.current = values;
    modelRef.count = tempInputValues.value[values.id] || 1;
    emits('update:currentPackage', values);
    emits('update:count', modelRef.count);
  }
};

const handleInputChange = (value: valueType) => {
  if (value > modelRef.current?.max) {
    modelRef.count = modelRef.current?.max;
    emits('update:count', modelRef.current?.max);
    tempInputValues.value[modelRef.current?.id] = modelRef.current?.max;
  } else {
    tempInputValues.value[modelRef.current?.id] = Number(value) || 1;
    const fmtValue = parseInt(`${value}`);
    modelRef.count = fmtValue;
    emits('update:count', fmtValue);
  }
};

const { $dayjs } = useTime();
const expireFormat = () => $dayjs().add(1, 'year').format('YYYY/MM/DD');

onMounted(() => {
  if (props?.currentPackage) {
    modelRef.current = props.currentPackage;
  }
});
</script>

<style lang="scss" scoped>
.buy-feature {
  @apply w-full p-[30px];
  &__desc {
    padding-top: 16px;
    padding-bottom: 20px;
    color: var(--text-1);
    font-size: 14px;
    line-height: 24px;
    opacity: 0.6;
  }
  &__block {
    margin-top: 30px;
    display: flex;
    align-items: center;
    // column-gap: 20px;
    &--label {
      width: 48px;
      opacity: 0.6;
    }
  }
  .product_list {
    @apply flex justify-center gap-[20px];
    .product_item {
      @apply bg-back-3 rounded-[12px] p-[18px_20px] transition-colors relative cursor-pointer;
      border: 2px solid transparent;

      &.selected {
        border-color: var(--purple-5);
      }
    }
  }
}
</style>
